import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ChartingState } from './charting.reducer';
import { chartingStateKey } from './charting.state-key';

const selectApp = createFeatureSelector<ChartingState>(chartingStateKey);

export const selectLastToothPosition = createSelector(selectApp, (s) => s.lastToothPosition);
export const selectScreen = createSelector(selectApp, (s) => s.screen);
export const selectViewToggle = createSelector(selectApp, (s) => s.viewToggle);
